import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useEffect, useMemo } from 'react';
import { RegisterContact } from './RegisterContact.jsx';

import { shallow } from 'zustand/shallow';
import { useUIStore } from '#store';
import { Entry } from '../Entry/Entry.jsx';
import { getDims } from '#utils';

export function ContactModal() {
  const {
    showContactModal,
    toggleContactModal,
    user,
    steps,
    currentPage,
    code,
    setShowPricingModal,
  } = useUIStore(
    (state) => ({
      showContactModal: state.showContactModal,
      toggleContactModal: state.toggleContactModal,
      user: state.user,
      steps: state.steps,
      currentPage: state.currentPage,
      code: state.code,
      setShowPricingModal: state.setShowPricingModal,
    }),
    shallow
  );

  const isUserVerified = () => {
    if (!user?.contacts?.[0]) return false;
    return user.contacts.some((c) => c.type === 'phone' && c.verified);
  };

  useEffect(() => {
    if (!showContactModal) return;
    if (!steps?.length) {
      // We are not in the checkout flow
      if (user?._id) {
        // the user logged in, close the modal
        toggleContactModal(false);
      }
    } else {
      // We are in the checkout flow
      if (isUserVerified()) {
        // We are already verified
        toggleContactModal(false);
        if (steps?.[0] === 'pricingModal') {
          if (currentPage !== 'profile' && code !== 'YEAROFF') {
            // Don't show pricing in case of affiliates
            setShowPricingModal(true);
          }
        }
      } else {
        // We need to verify the phone number
        toggleContactModal(true);
      }
    }
  }, [steps, user, showContactModal]);

  let shownComponent = <Entry />;
  if (user?._id) {
    shownComponent = <RegisterContact />;
  }

  const { height } = getDims();
  const marginTop = height < 800 ? 0 : 16;

  return (
    <Modal
      isOpen={showContactModal}
      onClose={() => toggleContactModal(false)}
      size="5xl"
    >
      <ModalOverlay />
      <ModalContent bg="gray.100" mt={marginTop}>
        {shownComponent}
        <ModalCloseButton color={'white'} />
      </ModalContent>
    </Modal>
  );
}
